import React from 'react'
import { Box } from '@mui/material'
import { useParams } from 'react-router'
import Header from 'components/Header'
import JobEmploymentTable from 'components/JobEmploymentTable'

const PracticeJobEmploymentList: React.FC = () => {
    const params = useParams()
    const practiceId = React.useMemo(() => Number(params.practiceId), [params.practiceId])
    
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, height: '100%' }}>
            <Header text='Timesheets' />
            <JobEmploymentTable practice_id={practiceId} canSearchByPractice={false} />
        </Box>
    )
}

export default PracticeJobEmploymentList